import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PERMISSION_GDPR_PROFILE_LIST } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import GdprProfileHistory from '../../components/GdprProfile/GdprProfileHistory';

export const Route = createFileRoute('/_authenticated/gdpr-profile/history')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_GDPR_PROFILE_LIST, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'tab.gdpr/profile/history',
        suffix: 'menu.gdprProfiles',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: GdprProfileHistoryRoute,
});

function GdprProfileHistoryRoute() {
  return (
    <>
      {/* Always render the list */}
      <GdprProfileHistory />
      {/* Outlet will render child routes (detail modal, etc.) on top */}
      <Outlet />
    </>
  );
}
